import BuyModal from './buy-modal';

export default BuyModal;
